<section class="container has-text-justified">
  <div class="columns is-multiline">
    <div class="column is-12 pb-6">
      <h1 class="title is-4">{{ 'homepage.chooseOption.title' | localize }}</h1>
    </div>

    <div class="column is-4">
      <div class="card">
        <div class="card-content">
          <div class="content">
            <div class="columns">
              <div class="column is-1">
                  <span class="icon">
                    <i class=" fas fa-2x fa-solid fa-arrow-up-from-bracket"></i>
                  </span>
              </div>
              <div class="column has-text-left is-offset-1">
                <p class="title is-4 pb-4">{{ 'homepage.claimUpload.title' | localize }}
                  <br>
                  <span class="subtitle">{{ 'menu.createClaim.earthquake.label' | localize }}</span>
                </p>
                <p class="subtitle is-6">{{ 'homepage.claimUpload.description' | localize }}</p>
              </div>
            </div>
            <div class="columns has-text-centered">
              <div class="column is-10 is-offset-1">
                <button class="button is-black is-fullwidth"
                        routerLink="/forms/submit/earthquake">{{ 'Earthquake' | localize }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="column is-4">
      <div class="card">
        <div class="card-content">
          <div class="content">
            <div class="columns">
              <div class="column is-1">
                  <span class="icon">
                    <i class=" fas fa-2x fa-solid fa-arrow-up-from-bracket"></i>
                  </span>
              </div>
              <div class="column has-text-left is-offset-1">
                <p class="title is-4 pb-4">{{ 'homepage.claimUpload.title' | localize }}
                  <br>
                  <span class="subtitle">{{ 'menu.createClaim.flood.label' | localize }}</span>
                </p>
                <p class="subtitle is-6">{{ 'homepage.claimUpload.description' | localize }}</p>
              </div>
            </div>
            <div class="columns has-text-centered">
              <div class="column is-10 is-offset-1">
                <button class="button is-black is-fullwidth"
                        routerLink="/forms/submit/flood">{{ 'Flood' | localize }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>
